import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=38fa896a&"
import script from "./ClientInformation.vue?vue&type=script&lang=js&"
export * from "./ClientInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClientInformation.vue?vue&type=style&index=0&id=38fa896a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports